<template>
  <div>
    <div
      v-if="userInvite.status != 'submitted' && userInvite.status != 'emailed'"
      id="inviter"
    >
      <h3 v-if="!userInvite.newProfile">
        Share your {{ userInvite.profileName }} profile with a collaborator.
      </h3>
      <h3 v-if="userInvite.newProfile && invitedRole == 'Venue'">
        Invite a venue to use Gobo.
      </h3>
      <h3 v-if="userInvite.newProfile && invitedRole == 'Artist'">
        Invite an artist to use Gobo.
      </h3>
      <div class="field">
        <label class="label">{{ invitedRole }} Name</label>
        <div class="control">
          <input
            type="text"
            class="input"
            v-model="userInvite.profileName"
            disabled="true"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ invitedRole }} Email</label>
        <div class="control">
          <input type="text" class="input" v-model="userInvite.email" />
        </div>
      </div>
      <div class="field">
        <label class="label">Email Message</label>
        <div class="control">
          <textarea type="text" class="textarea" v-model="userInvite.message" />
        </div>
      </div>
      <div class="buttons is-centered">
        <button v-if="false" class="button" @click="cancel">Cancel</button>
        <button
          class="button is-primary"
          @click="confirm"
          :disabled="!emailValid"
          :class="{ 'is-loading': inProgress }"
        >
          Send Invite
        </button>
      </div>
    </div>

    <div
      id="invited"
      class="has-text-centered"
      v-if="userInvite.status == 'submitted' || userInvite.status == 'emailed'"
    >
      <h3>An invite has been sent to {{ userInvite.email }}!</h3>
      <p>Thank you for sharing the Gobo experience!</p>
      <div class="figure">
        <img src="/img/illustration-email.png" alt="email sent" />
      </div>
      <div class="buttons is-centered">
        <button class="button" @click="resetInvite">
          Invite another collaborator
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { mapGetters } from "vuex";

export default {
  name: "InviteArtist",
  data() {
    return {
      // eslint-disable-next-line no-useless-escape
      emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  computed: {
    ...mapGetters({
      userInvite: "userInvite",
      user: "user" // Need the current user for the email message
    }),
    emailValid() {
      return this.emailRegex.test(this.userInvite.email);
    },
    invitedRole() {
      if (this.userInvite.festivalId) return "Festival";
      return this.userInvite.venueId ? "Venue" : "Artist";
    },
    inProgress() {
      return (
        this.userInvite.status == "submitting" ||
        this.userInvite.status == "submitted"
      );
    }
  },
  created() {
    // Set the specific email message requested in the ticket
    if (this.user && this.userInvite) {
      const userName = this.user.name || "A user";
      const profileName = this.userInvite.profileName || "their profile";
      const role = this.invitedRole.toLowerCase();

      this.userInvite.message = `${userName} is inviting you to collaborate on the ${role} profile for ${profileName} on Gobo.`;
    }
  },
  methods: {
    cancel() {
      store.dispatch("confirm", false);
      this.$emit("canceled");
    },
    confirm() {
      console.log("sending invite");
      this.userInvite.status = "submitting";
      store.dispatch("submitInvite", this.userInvite);
    },
    resetInvite() {
      // Reset status to allow inviting another person
      this.userInvite.status = "idle";
      this.userInvite.email = "";
    }
  }
};
</script>

<style scoped>
.figure {
  display: flex;
  padding: 40px;
  justify-content: center;
}
</style>
